/**
 * Иконочный пак YUC Portal.
 *
 *   import { IconPlanning, IconLaunch } from "@/components/ui/icons";
 *   <IconPlanning size={16} />
 *
 * Все иконки: грид 24×24, currentColor, size в px (rem проекта = 12px!),
 * пропсы size / strokeWidth / duotone / className / title.
 * Превью и каталог: /icons (только dev).
 */
export * from "./icons";
export type { IconProps } from "./icon-base";
